import {
  BrilliantDeviceTypes,
  IBrilliantPlugCard,
} from "../../interfaces/interfaces";
import { ReactComponent as Plug } from "../../img/Devices/Plug.svg";

import BrilliantDeviceCard from "./BrilliantDeviceCard";

const plugIcon = (isReconfiguring: boolean) => {
  return (
    <Plug
      title="Smart Plug"
      className={
        isReconfiguring
          ? "brilliant-card-img-left brilliant-card-img-stroke disabled"
          : "brilliant-card-img-left brilliant-card-img-stroke"
      }
    />
  );
};

export interface BrilliantPlugCardProps {
  data: IBrilliantPlugCard;
  isSmartCardCredentialsEnabledStories?: boolean;
  isProView?: boolean;
}

const BrilliantPlugCard: React.FC<BrilliantPlugCardProps> = ({
  data,
  isProView,
}) => {
  return (
    <div>
      <BrilliantDeviceCard
        id={data.id}
        name={data.name}
        description="Smart Plug"
        isReconfiguring={data.isReconfiguring}
        icon={plugIcon(data.isReconfiguring)}
        isProView={isProView}
        shouldShowSettingsRender={isProView}
        deviceType={BrilliantDeviceTypes.PLUG}
      />
      {isProView && <div className="brilliant-card-container-reboot" />}
    </div>
  );
};
export default BrilliantPlugCard;
